import { nextTick, Ref, watch } from '@vue/composition-api'

export function useLoaded(condition: Ref<boolean>, cb: () => any) {
  watch(condition, value => {
    if (!value) {
      nextTick(cb)
    }
  })
}
